<style lang="scss">
  .footer {
    margin-top: auto;
    position: sticky;
    bottom: 0;
    background: white;
  }

  .divider {
    height: 1px;
    background-color: #eaecf0;
    margin: 0;
    width: 100%;
  }

  .button-container {
    display: flex;
    padding: 12px 24px;
    justify-content: flex-end;
    align-items: center;
    gap: 17px;
    background: white;
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { kindStore, selectedLicenseKindsStore } from "../stores";
  export let onSave;
  export let cancel;

  $: requiresLicense = ["user", "superUser"].includes($kindStore);
  $: disabled = requiresLicense && $selectedLicenseKindsStore.length === 0;
</script>

<div class="footer">
  <div class="divider"></div>
  <div class="button-container">
    <Button class="flex-1" kind="ghost-blue" size="large" onclick={cancel}
      >Cancel</Button
    >

    {#if disabled}
      <ButtonWithTooltip
        class="flex-1 {disabled ? 'disabled' : ''}"
        leadingIcon="fas fa-plus"
        kind="primary"
        size="large"
        onclick={onSave}
        {disabled}
        placement="top"
      >
        <span slot="tooltip">Please select at least one license type</span>
        Add Users
      </ButtonWithTooltip>
    {:else}
      <Button
        class="flex-1"
        leadingIcon="fas fa-plus"
        kind="primary"
        size="large"
        onclick={onSave}
      >
        Add Users
      </Button>
    {/if}
  </div>
</div>
